<template>
  <div>
    <div class="d-flex justify-content-between flex-row-column">
      <headnavigation :flow="flow" />
      <span class="input-width-160 r-width-100 d-inline-block">
        <md-field>
          <label>Search</label>
          <md-input v-on:keyup="search" v-model="search_term"></md-input>
          <md-icon>search</md-icon>
        </md-field>
      </span>
    </div>
    <hr class="mt-0" />
    <b-row class="mt-4" v-if="data.info">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-3" src="../../../assets/icons/iconGeneralAgentInfo.svg" alt="bank" />
      </b-col>
      <b-col md="5">
        <div class="d-flex">
          <div class="gray-text width-200">Date Created</div>
          <div class="d-inline-block">
            <print :text="data.info['Date Created']" />
          </div>
        </div>
        <div v-if="data.info['LMT']" class="d-flex">
          <div class="gray-text width-200">{{ $tc('general.lmt', 1) }}</div>
          <div class="d-inline-block">
            <router-link :to="'/bank/lmt/'+data.lmt_id">
              <print :text="data.info['LMT']" />
            </router-link>
          </div>
        </div>
        <div v-else class="d-flex">
          <div class="gray-text width-200">{{ $tc('general.agent', 1) }}</div>
          <div class="d-inline-block">
            <router-link v-if="data.agent" :to="'/bank/agents/'+data.agent.id">
              <print :text="data.info['Agent']" />
            </router-link>
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Street</div>
          <div class="d-inline-block">
            <print :text="data.info['Street']" />
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="d-flex">
          <div class="gray-text width-200">City</div>
          <div class="d-inline-block">
            <print :text="data.info['City']" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">State</div>
          <div class="d-inline-block">
            <print :text="data.info['State']" />
          </div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Zip Code</div>
          <div class="d-inline-block">
            <print :text="data.info['Zip Code']" />
          </div>
        </div>
      </b-col>
    </b-row>
    <hr class="mb-0" />
    <div class="d-flex justify-content-between flex-row-column">
      <span class="page-title mt-3">Monthly Deposit Made</span>
      <span v-if="subrole.name != 'compliance_company'" class="my-1">
        <md-button @click="acknowledge_popup=1" class="md-primary md-raised c-primary">Acknowledge</md-button>
        <a :href="'mailto: '+data.email">
          <md-button class="md-primary md-raised c-primary">Send Email Reminder</md-button>
        </a>
      </span>
    </div>
    <hr class="mb-0 mt-0" />
    <div id="pdf">
      <md-table
        :md-sort-fn="orderBy"
        v-if="items.data"
        v-model="items.data"
        v-show="!loading"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortOrder"
      >
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell
            :class="{ 'red-cell': item.red_flag}"
            md-label="Date"
            md-sort-by="date"
          >{{ item.date }}</md-table-cell>
          
          <md-table-cell
            v-if="data.name=='Outside their Expected Average Transaction Amount'"
            md-label="Actual Average Amount"
            md-sort-by="actual"
          >${{ Number(item.actual).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</md-table-cell>
          <md-table-cell
            v-else-if="data.name=='Outside their Expected Monthly Number of Transactions'"
            md-label="Total transactions"
            md-sort-by="actual"
          >{{ parseInt(item.actual)}}</md-table-cell>
          <md-table-cell
            v-else-if="data.name=='Outside their Expected Monthly Volume'"
            md-label="Total Deposits"
            md-sort-by="actual"
          >${{ Number(item.actual).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</md-table-cell>
          <md-table-cell md-label="Balance" v-else>{{item.actual}}</md-table-cell>

          <md-table-cell
            v-if="data.name=='Outside their Expected Average Transaction Amount'"
            md-label="Expected Average Amount"
            md-sort-by="actual"
          >${{ Number(item.expected).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</md-table-cell>
          <md-table-cell
            v-else-if="data.name=='Outside their Expected Monthly Number of Transactions'"
            md-label="Expected transactions"
            md-sort-by="actual"
          >{{ Number(item.expected).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</md-table-cell>
          <md-table-cell
            v-else-if="data.name=='Outside their Expected Monthly Volume'"
            md-label="Expected Deposits"
            md-sort-by="actual"
          >${{ Number(item.expected).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</md-table-cell>
          <md-table-cell md-label="Allowed Discrepancy" v-else>${{Number(item.expected).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</md-table-cell>

          <md-table-cell md-label="Variation" md-sort-by="percentage">{{ item.percentage }}</md-table-cell>
        </md-table-row>
      </md-table>
      <GChart
        v-if="chartData.length>1"
        type="ColumnChart"
        :data="chartData"
        :options="chartOptions"
      />
    </div>

    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items&&pagination"
      :meta="pagination.meta"
      :links="pagination.links"
      :per_page="per_page"
    />

    <empty-state v-if="!loading&&items.length==0" />
    <loading v-if="loading" />
    <acknowledge
      v-if="acknowledge_popup"
      :id="$route.params.red_flag_id"
      v-on:cancel="acknowledge_popup=0"
    />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";

import Acknowledge from "../../../components/bank/AcknowledgeRedFlag";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  mixins: [DataMixin, Pagination],

  components: { acknowledge: Acknowledge },

  data() {
    return {
      chartData: [["Year", "Expected", "Actual"]],
      acknowledge_popup: 0,
      chartOptions: {
        vAxis: {minValue: 0},
        title: "Actual vs Expected",
        titlePosition: "top",
        chartArea: { left: 60, top: 80 },
        titleAlignment: "start",
        titleTextStyle: {
          color: "#012C57",
          fontSize: 15
        },
        colors: ["#499BCD", "#506E8B"],
        height: 380,
        hAxis: {
          textStyle: {
            color: "#8A9DB1",
            fontSize: 15
          },
          titleTextStyle: {
            color: "#8A9DB1",
            fontSize: 15
          }
        },
        vAxis: {
          textStyle: {
            color: "#8A9DB1",
            fontSize: 15
          },
          titleTextStyle: {
            color: "#8A9DB1",
            fontSize: 15
          }
        },
        legend: {
          textStyle: {
            color: "#8A9DB1",
            fontSize: 15
          },
          position: "top",
          alignment: "end"
        }
      },
      flow: [
        { text: "Red Flags", link: "/bank/red-flags" },
        { text: "" },
        { text: "" }
      ],
      per_page: 10,
      search_term: "",
      // url for loading data
      api_url: "/red-flags/get?red_flag_id=" + this.$route.params.red_flag_id,
      page: 1,
      //IMPORTANT loaded data is stored in items
      items: [],
      filtered: false,
      details_data: {},
      data: {},
      search_term: "",
      pdfProgress: -1,
      subrole:window.auth.getSubRole()
    };
  },
  created() {
    this.loadInitalData();
  },
  methods: {
    clearAll() {
      this.$router
        .push({
          path: this.$route.path
        })
        .catch(err => {});
      location.reload();
    },
    loadInitalData() {
      axios
        .get(this.api_url)
        .then(({ data }) => {
          this.data = data;
          this.items = data.data;
          this.loading = false;
          this.pagination = this.items.data;
          if (data.info.Agent) {
            this.flow[1].link = "/bank/red-flags/" + data.agent.lmt_id;

            this.flow[1].text = data.info.Agent;
          } else {
            
            this.flow[1].text = data.info.LMT;
          }
           this.flow[1].link = "/bank/red-flags/" + data.bank_lmt.id;
           

          this.flow[2].text = data.name;

          this.items.data.forEach(element => {
            this.chartData.push([
              element.percentage + " \n " + element.date,
              element.expected ? parseFloat(element.expected) : 0,
              element.actual ? parseFloat(element.actual) : 0
            ]);
          });
            if(this.data.name!='Outside their Expected Monthly Number of Transactions')
         this.chartOptions.vAxis.format='$#';
        
        })
        .catch(error => {
          //this.$router.push("/owner/agents");
        });
    },
    details(data) {
      Event.$emit("overlay", data);
    },
    createPDF(index) {
      if (index > -1) this.pdfProgress = index;
      var quotes = document.getElementById("pdf");

      if (quotes) {
        html2canvas(quotes, {
          scale: 1
        }).then(canvas => {
          var pdf = new jsPDF("pt", "pt", "letter");

          for (var i = 0; i <= quotes.clientHeight / 1274; i++) {
            //! This is all just html2canvas stuff
            var srcImg = canvas;
            var sX = 0;
            var sY = 1274 * i; // start PDF_PAGE_HEIGHT pixels down for every new page
            var sWidth = 900;
            var sHeight = 1274;
            var dX = 0;
            var dY = 0;
            var dWidth = 900;
            var dHeight = 1274;

            window.onePageCanvas = document.createElement("canvas");
            window.onePageCanvas.setAttribute("width", 900);
            window.onePageCanvas.setAttribute("height", 1274);
            var ctx = window.onePageCanvas.getContext("2d");

            ctx.drawImage(
              srcImg,
              sX,
              sY,
              sWidth,
              sHeight,
              dX,
              dY,
              dWidth,
              dHeight
            );

            // document.body.appendChild(canvas);
            var canvasDataURL = window.onePageCanvas.toDataURL(
              "image/png",
              1.0
            );

            var width = window.onePageCanvas.width;
            var height = window.onePageCanvas.clientHeight;

            //! If we're on anything other than the first page,
            // add another page
            if (i > 0) {
              pdf.addPage(612, 791); //8.5" x 11" in pts (in*72)
            }

            pdf.setPage(i + 1);
            pdf.addImage(
              canvasDataURL,
              "PNG",
              20,
              0,
              width * 0.62,
              height * 0.62
            );
          }
          //! after the for loop is finished running, we save the pdf.
          pdf.save(this.data.info.Agent + "-" + this.data.name + ".pdf");
          this.pdfProgress = -1;
        });
      } else {
        setTimeout(() => {
          this.createPDF(false);
        }, 300);
      }
    }
  }
};
</script>